<template>
  <v-container
    id="login"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="coolrunner"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="text-h2 font-weight-bold">
                {{ $t('login') }}
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <v-text-field
              v-model="email"
              color="secondary"
              :label="$t('email') + '...'"
              prepend-icon="mdi-email"
            />

            <v-text-field
              v-model="password"
              type="password"
              class="mb-8"
              color="secondary"
              :label="$t('password') + '...'"
              prepend-icon="mdi-lock-outline"
              @keypress.enter="login"
            />

            <pages-btn
              large
              color=""
              depressed
              :loading="loading"
              class="v-btn--text success--text"
              @click="login"
            >
              Let's Go
            </pages-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  import localStorage from '../../plugins/localstorage'
  import { URL_PREFIX } from '../../utils/constants'

  export default {
    name: 'PagesLogin',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    data: () => ({
      password: '',
      email: '',
      loading: false,
    }),
    created: function () {
      const { email = '', password = '' } = this.$route.params
      this.email = email
      this.password = password
    },
    methods: {
      login: function () {
        this.loading = true
        this.$post(`${URL_PREFIX}/oauth/token`, {
          grant_type: 'password',
          username: this.email,
          password: this.password,
          client_id: process.env.VUE_APP_AUTH_CLIENT_ID,
          client_secret: process.env.VUE_APP_AUTH_CLIENT_SECRET,
        })
          .then(({ data = {}, ...resp }) => {
            this.loading = false
            if (!data.access_token) { return }

            localStorage.set('token', data.access_token)
            localStorage.set('token_expires', data.expires_in)
            if (localStorage.get('token') != null) {
              this.$get('/user/auth').then(({ data: d = {} }) => {
                if (!d.response_data) {
                  localStorage.clear('token')
                  localStorage.clear('token_expires')
                  return
                }

                localStorage.set('user', JSON.stringify(d.response_data.user))
                localStorage.set('user_id', d.response_data.user.id)

                this.$emit('loggedIn')
                if (this.$route.params.nextUrl != null) {
                  this.$router.push(this.$route.params.nextUrl)
                } else {
                  this.$router.push('/')
                }
              })
            }
          })
          .catch(e => {
            this.loading = false
          })
      },
    },
  }
</script>
